import errorAnimationJson from "@repo/core/assets/animations/error-alert.json";
import warningAnimationJson from "@repo/core/assets/animations/warning-alert.json";
import checkAnimationJson from "@repo/core/assets/animations/success-alert.json";
import { IconNames } from "@repo/core/components/core/Icon/types";
import { LottieFileConfig } from "@repo/core/components/core/LottieAnimation/types";

import { AlertModalVariant } from "./types";

export const AlertStyleMap: Record<
  AlertModalVariant,
  {
    icon: IconNames;
    lottieFileConfig: LottieFileConfig;
    iconVariant?: "regular" | "solid";
    iconColor: string;
  }
> = {
  [AlertModalVariant.success]: {
    icon: "check-circle",
    iconColor: "$primary600",
    lottieFileConfig: new LottieFileConfig({
      file: checkAnimationJson,
      width: "$16",
      height: "$12",
      duration: 150
    })
  },
  [AlertModalVariant.error]: {
    icon: "times-circle",
    iconColor: "$error600",
    lottieFileConfig: new LottieFileConfig({
      file: errorAnimationJson,
      width: "$16",
      height: "$12",
      duration: 180
    })
  },
  [AlertModalVariant.warning]: {
    icon: "times-circle",
    iconColor: "$warning600",
    lottieFileConfig: new LottieFileConfig({
      file: warningAnimationJson,
      width: "$16",
      height: "$12",
      duration: 180
    })
  }
};
